import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-toast-component',
    templateUrl: './toast-component.component.html',
    styleUrls: ['./toast-component.component.scss'],
    standalone: false
})
export class ToastComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
